import { ModelsStateActions, SET_MODELS } from './types';
import { ModelsData } from 'sofa-reborn-react';

export function setModels(value: ModelsData): ModelsStateActions {
	return {
		type: SET_MODELS,
		value,
	};
}
